import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { fetchSeenNews } from './thunks';
import type { AdminStatus, UserData, UserSeenNews, UserState } from './types';

const initialState: UserState = {
  userData: {},
  userSeenNews: false,
  isAdmin: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      state.userData = action.payload;
    },
    setSeenNews: (state, action: PayloadAction<UserSeenNews>) => {
      state.userSeenNews = action.payload;
    },
    setAdmin: (state, action: PayloadAction<AdminStatus>) => {
      state.isAdmin = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchSeenNews.fulfilled, (state, action) => {
      state.userSeenNews = action.payload;
    });
  },
});

export const { setUser, setSeenNews, setAdmin } = userSlice.actions;
export const userReducer = userSlice.reducer;
